import React from 'react';
import { Tooltip, Fade } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { MenuItem } from 'react-pro-sidebar';

interface ReusableMenuItemProps {
  title: string;
  icon: React.ReactNode;
  path: string;
  suffix?: any;
}

const SimpleMenuItem: React.FC<ReusableMenuItemProps> = ({ title, icon, path, suffix }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Tooltip
      disableInteractive
      title={title}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 600 }}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -10],
              },
            },
          ],
        },
      }}
      placement="right"
    >
      <MenuItem
        suffix={suffix}
        icon={icon}
        rootStyles={{
          background:
            location.pathname === path ? 'rgb(255 255 255 / 12%)' : '',
        }}
        onClick={(event: any) => {
          if (event.metaKey || event.ctrlKey) {
            window.open(path, '_blank');
          } else {
            navigate(path);
          }
        }}
      >
        {title}
      </MenuItem>
    </Tooltip>
  );
};

export default SimpleMenuItem;
